const mapWrapper = document.querySelectorAll('[data-ymap]')
const mapNumber = mapWrapper.length

/* eslint-disable */
if (mapNumber) {
  ymaps.ready(function () {
    mapWrapper?.forEach((map) => {
      if (map.dataset.ymapId) {
        ymaps.findOrganization(map.dataset.ymapId).then(orgGeoObject => {
          const myMap = new ymaps.Map(map, {
            center: orgGeoObject.geometry._coordinates,
            zoom: 15,
            controls: [],
          });
          myMap.geoObjects.add(orgGeoObject);
          orgGeoObject.balloon.open();
          myMap.controls.add('zoomControl');
          myMap.controls.remove('rulerControl');
        });
        return;
      }
      const myMap = new ymaps.Map(map, {
        center: [55.684758, 37.738521],
        zoom: 7,
        controls: [],
      })

      myMap.controls.add('zoomControl')
      myMap.controls.remove('rulerControl')
    })
  })
}
/* eslint-enable */
